import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Container, Spinner } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import whiteBg from "../../assets/images/whiteBg.jpg";
import AppContext from "../../context/AppContext";
import { onPageHeadSEO, scrollToTop } from "../../helper/HelperFunctions";
import MasterLayout from "../../layout/MasterLayout";
import { useLocation } from "react-router-dom";

const PaymentVerification = () => {
  const { baseUrl, navigate } = useContext(AppContext);
  const location = useLocation();
  const [checkoutStatus, setCheckoutStatus] = useState();
  const [isStatusVerified, setIsStatusVerified] = useState(true);

  const markOrderAsComplete = (checkoutSessionId) => {
    const formData = new FormData();
    const user_id = localStorage.getItem("device_id");

    formData.append("user_id", user_id);
    formData.append("checkoutSession", checkoutSessionId);

    axios
      .post(`${baseUrl}/api/guest/completeOrderAfterPayment`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data.success);
        setIsStatusVerified(false);
        // navigate("/");
      })
      .catch((error) => {
        console.log(error);
        setIsStatusVerified(false);
      });
  };

  const deleteOrderForNoPayment = () => {
    const formData = new FormData();
    const user_id = localStorage.getItem("device_id");

    formData.append("user_id", user_id);

    axios
      .post(`${baseUrl}/api/guest/deleteOrderForNoPayment`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data.success);
        // navigate("/");
        setIsStatusVerified(false);
      })
      .catch((error) => {
        console.log(error);
        setIsStatusVerified(false);
      });
  };

  useEffect(() => {
    scrollToTop();
    const searchParams = new URLSearchParams(location.search);
    const sc_checkout = searchParams.get("sc_checkout");
    if (sc_checkout == "success") {
      setCheckoutStatus("success");
      const checkoutSession = searchParams.get("sc_sid");
      markOrderAsComplete(checkoutSession);
    } else {
      deleteOrderForNoPayment();
    }
    onPageHeadSEO(
      "FixTech Expert",
      "FixTechExpert - Payment Verification.",
      "FixtechExpert,Discounted Repairing"
    );
  }, []);

  return (
    <MasterLayout>
      {/* MOBILE BRANDS */}

      {/* What we offer you - Cars */}
      <Container
        fluid
        className="m-0 d-flex flex-column pt-5 align-items-center"
        style={{ background: `url(${whiteBg})`, height: "100vh" }}
      >
        {checkoutStatus == "success" ? (
          <>
            <h1>Congratulations</h1>
            <h5>
              Your payment has been processed. We will proceed with your order
              as soon as possible.
            </h5>
            {isStatusVerified ? (
              <Spinner className="txt-green" />
            ) : (
              <Button
                onClick={() => {
                  navigate("/");
                }}
                className="btn btn-success"
              >
                GO TO HOME
              </Button>
            )}
          </>
        ) : (
          <>
            <h1>Oops</h1>
            <h5>You have cancelled the payment process.</h5>
            {isStatusVerified ? (
              <Spinner className="txt-green" />
            ) : (
              <Button
                onClick={() => {
                  navigate("/");
                }}
                className="btn btn-success"
              >
                GO TO HOME
              </Button>
            )}
          </>
        )}
      </Container>
    </MasterLayout>
  );
};

export default PaymentVerification;
